export class DataProvider {
  public static SE: string = "SE";
  public static Z2DATA: string = "Z2DATA";
}
